import React from "react";
import { useRetrieveProjectPortfolios } from "@planzone/view-models";
import { Identifiable, Project, ProjectPortfolio } from "@planzone/dto";
import { ProjectPortfolioTag } from "./portfolio";
import { PortfolioAssignation } from "@common/portfolioAssignation";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { AddIcon } from "./addIcon";
import styles from "./styles.scss";
import { Props } from "./types";

function extractAssignedPortfolios(
  project: Identifiable<Project>,
  portfolios: Identifiable<ProjectPortfolio>[],
): Identifiable<ProjectPortfolio>[] {
  return portfolios.reduce<Identifiable<ProjectPortfolio>[]>(
    (sum, portfolio) =>
      !!portfolio.projects.find(({ uuid }) => uuid === project.uuid)
        ? [...sum, portfolio]
        : sum,
    [],
  );
}

function ProjectPortfoliosList({ project, isRemovable, remove }: Props) {
  const { portfolios } = useRetrieveProjectPortfolios();
  const assignedPortfolios = extractAssignedPortfolios(project, portfolios);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.tagList}>
          <div className={styles.tags}>
            {assignedPortfolios.map((portfolio) => (
              <ProjectPortfolioTag
                key={portfolio.uuid}
                {...portfolio}
                isRemovable={isRemovable}
                remove={() => remove && remove(portfolio)}
              />
            ))}
            <div onClick={isVisible ? hide : show}>
              <AddIcon className={styles.icon} />
            </div>
          </div>
          {isVisible && (
            <div className={styles.form}>
              <PortfolioAssignation project={project} />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ProjectPortfoliosList };
